import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * Button, the legacy generic button.
 *
 * CSS selector: `mobile/atoms.css` `.ds-btn` (+ `--primary`, `--commit`,
 * `--secondary`, `--ghost`, `--danger`, `--sm`, `--lg`, `--tall`, `--block`).
 *
 * DEPRECATED as a whole for new mobile work: reach for `<Cta>` instead, which
 * is the mobile commit button. This component exists only so markup that
 * already references `.ds-btn` keeps working through the conversion.
 *
 * `variant="primary"` is DEPRECATED specifically and doubly so. It emits
 * `.ds-btn--primary`, an accent-filled button, which violates the doctrine
 * that ink is command and accent is state. Use `commit` (ink) instead. The
 * variant stays in the lookup table only so existing templates do not break.
 *
 * Doctrine also enforced here: disabled is a flat desaturated grey supplied by
 * the CSS, never an opacity fade.
 */
const BUTTON_VARIANT = {
  // DEPRECATED, accent fill. Use `commit`.
  primary: 'ds-btn--primary',
  commit: 'ds-btn--commit',
  secondary: 'ds-btn--secondary',
  ghost: 'ds-btn--ghost',
  danger: 'ds-btn--danger',
};

const BUTTON_SIZE = {
  base: null,
  sm: 'ds-btn--sm',
  lg: 'ds-btn--lg',
  tall: 'ds-btn--tall',
};

export const Button = React.forwardRef(function Button(
  { className, variant = 'commit', size = 'base', block = false, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'ds-btn',
        BUTTON_VARIANT[variant],
        BUTTON_SIZE[size],
        block && 'ds-btn--block',
        className,
      )}
      {...rest}
    />
  );
});

export default Button;
